import { LittleModalCreateEdit } from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { valueOrDefaultValue } from '../../../../../../utils/globals/valueOrDefaultValue'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { ServiceTypeModelType } from '@teinor/erp/types/company/config/serviceType'
import { getAllGroupVats } from '../../../../../../utils/reducers/getters'


type ModalCEServiceTypeProps = ModalEditComponentProps  & {}

const ModalCEServiceType: React.FC<ModalCEServiceTypeProps> = ({ allRowData, userPermissions, ...rest }) => {
    const { t } = useTwinTranslation()
    const groupVats = getAllGroupVats()
    const fields: FormRender<ServiceTypeModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'billing_code',
                    label: t('billingCode', 'Código de facturación'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'GroupVatId',
                    label: t('groupVat', 'Grupo de impuestos'),
                    component: 'CustomSelectWithSearchBar',
                    items: groupVats || {},
                    required: true
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        },
    ]

    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/config/serviceType/updateServiceType'} translations={{ title: t('editServiceType', 'Editar Tipo de servicio'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/serviceType/createServiceType'} translations={{
        title: t('createServiceType', 'Crear Tipo de servicio'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}




export default ModalCEServiceType